module.exports = "https://static.wanderu.com/ui-react/_next/static/media/trustpilot-logo.fbafabcb.svg";